<template>
    <div class="halogenalkane">
        <ul>
            <li>RX (X = Halogen)</li>
            <li>-halogenide</li>
            <li>Halogen-</li>
            <li>unpolar</li>
            <li>rel. hohe Siedetemp.</li>
            <li>unlöslich in Wasser</li>
            <li>Beilsteinprobe</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'halogenalkane',
};
</script>
